import $ from 'jquery';

$(document).ready(function () {
  acfMapBlock();
});

function acfMapBlock() {
  $('.js-acf-map-block').each(function () {});
}
